
export const ROW_AGGREGATE_COLUMN_ID = 'rowAggregate-iA%2'
export const CELL_TEXT_FOR_ITEM_EXCLUDED_FROM_ROW_AGGREGATE = '-'
